export const ROUTE_LOGIN = '/login';

export const ROUTE_LANDING = '/';
export const ROUTE_HOME = '/';
export const ROUTE_ABOUT_US = '/über-uns';
export const ROUTE_FAQ = '/faq';
export const ROUTE_CREDIT_CARD = '/kreditkarte';
export const ROUTE_CREDIT_CARD_FORM = `${ROUTE_CREDIT_CARD}/bilden`;
export const ROUTE_MOBILE_APP = '/mobile-app';
export const ROUTE_PRIVACY_POLICY = '/datenschutz-und-richtlinien';
export const ROUTE_TERMS_OF_USE = '/nutzungsbedingungen';
export const ROUTE_IMPRESSUM = '/impressum';

export const ROUTE_CREDIT_REQUEST = '/kreditanfrage';
export const ROUTE_CREDIT_REQUEST_BASIC_SHORT = 'basic';
export const ROUTE_CREDIT_REQUEST_FORM_SHORT = 'bilden';
export const ROUTE_CREDIT_REQUEST_EXISTS_SHORT = 'existiert';
export const ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT = 'dokumentation';
export const ROUTE_CREDIT_REQUEST_OVERVIEW_SHORT = 'überblick';
export const ROUTE_CREDIT_REQUEST_BASIC = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_BASIC_SHORT}`;
export const ROUTE_CREDIT_REQUEST_FORM = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_FORM_SHORT}`;
export const ROUTE_CREDIT_REQUEST_EXISTS = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_EXISTS_SHORT}`;
export const ROUTE_CREDIT_REQUEST_DOCUMENTATION = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT}`;
export const ROUTE_CREDIT_REQUEST_OVERVIEW = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_OVERVIEW_SHORT}`;

export const ROUTE_CREDIT_REQUEST_VERIFY = '/öffentlich/kredit';
export const ROUTE_CREDIT_CARD_REQUEST_VERIFY = '/öffentlich/karte';

export const ROUTE_ERROR_406 = '/fehler/406';
export const ROUTE_ERROR_500 = '/fehler/500';
export const ROUTE_ERROR_503 = '/fehler/503';

export const ROUTE_DOWNLOAD = '/herunterladen';